import { render, staticRenderFns } from "./TopProductList.vue?vue&type=template&id=083fab09&scoped=true"
import script from "./TopProductList.vue?vue&type=script&lang=js"
export * from "./TopProductList.vue?vue&type=script&lang=js"
import style0 from "./TopProductList.vue?vue&type=style&index=0&id=083fab09&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "083fab09",
  null
  
)

export default component.exports